import { render } from "./2point.vue?vue&type=template&id=ef1f3b4c&ts=true"
import script from "./2point.vue?vue&type=script&lang=ts"
export * from "./2point.vue?vue&type=script&lang=ts"

import "./2point.vue?vue&type=style&index=0&id=ef1f3b4c&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__